import { AllStatsDIRResponse } from '../../../../../types/api/endpoints/stats/stats.types';
import { STATS_ENDPOINTS } from '../../../../../utils/api/endpoints/statsEndpoints';
import { AllStatsSpecifiedCOMQueryParams } from './DashboardStatsDIR.types';

const PREFIX = '[allStatsSpecifiedCOMQuery]';

export const ALL_STATS_SPECIFIED_COM_QUERY_KEY = 'ALL_STATS_SPECIFIED_COM';

export const allStatsSpecifiedCOMQuery = async ({
  commercialId,
}: AllStatsSpecifiedCOMQueryParams) => {
  console.log(PREFIX, `Requesting all stats COM #${commercialId}...`);
  const response = await STATS_ENDPOINTS.allStatsSpecifiedCOM(commercialId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all stats COM #${commercialId}.`);
  return json as AllStatsDIRResponse;
};
